let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cuVen"), load("57vSc"), load("89b92")]).then(() => parcelRequire('6cfXd'));